import { useSyncExternalStore } from "react";

// Reads the theme straight off the <html data-theme> attribute rather than from
// React state, so any component can follow the theme without being wired to the
// toggle. Subscribing via MutationObserver keeps third-party providers (MUI)
// in step when the theme changes while they are mounted.
function subscribe(onChange) {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
  return () => observer.disconnect();
}

function getSnapshot() {
  return document.documentElement.getAttribute("data-theme") === "dark" ? "dark" : "light";
}

export default function useThemeMode() {
  // Third arg is the server/prerender snapshot — light, matching today's default.
  return useSyncExternalStore(subscribe, getSnapshot, () => "light");
}
